import { render, staticRenderFns } from "./bonuslist.vue?vue&type=template&id=5fbc216c&scoped=true"
import script from "./bonuslist.vue?vue&type=script&lang=js"
export * from "./bonuslist.vue?vue&type=script&lang=js"
import style0 from "./bonuslist.vue?vue&type=style&index=0&id=5fbc216c&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbc216c",
  null
  
)

export default component.exports